import { Themes } from '@ankr.com/ui';
import { Theme } from '@mui/material';

const premiumText = `linear-gradient(269.98deg, #5F87F4 0.02%, #A963FF 49.89%, #FF862A 99.98%)`;

export const premiumTextStyles = {
  display: 'inline',
  width: 'fit-content',
  backgroundImage: premiumText,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

export const premiumColor = `linear-gradient(270.26deg, #013CD3 0.23%, #6235D0 26.13%, #AF34B1 49.87%, #E85658 76.96%, #FF7710 99.78%)`;

const premiumDarkThemeColor = `linear-gradient(269.98deg, #5F87F4 0.02%, #A963FF 49.89%, #FF862A 99.98%)`;

export const premiumBackground = `linear-gradient(180deg, rgba(242, 245, 250, 0) 0%, #F0F1F2 100%), linear-gradient(270deg, #D0DCF9 0%, #E3DCFA 50%, #F4E7DE 100%)`;

export const enterpriseColor = `linear-gradient(269.98deg, rgb(47, 98, 241) 0.02%, rgb(141, 48, 255) 49.89%, rgb(255, 119, 16) 99.98%)`;

export const premiumGradient = `linear-gradient(270deg, #2F62F1 0.02%, #8D30FF 49.89%, #FF7710 99.98%)`;
export const commonShadow =
  '0px 5px 25px rgba(31, 34, 38, 0.1), 0px 10px 50px rgba(31, 34, 38, 0.1)';

export const tooltipBoxShadow =
  '0 3px 15px 0 rgba(31, 34, 38, 0.10), 0 2px 5px 0 rgba(31, 34, 38, 0.10)';

export const dialogHeaderGradient =
  'linear-gradient(180deg, rgba(242, 245, 250, 0.00) 0%, #F0F1F2 100%), linear-gradient(270deg, #D0DCF9 0%, #E3DCFA 50%, #F4E7DE 100%)';

export const isLightTheme = (theme: Theme) => {
  return theme.palette.mode === Themes.light;
};

export const getPremiumColorGradientHover = (theme: Theme) => {
  return isLightTheme(theme) ? premiumDarkThemeColor : premiumColor;
};

export const getPremiumColorGradient = (theme: Theme) => {
  return isLightTheme(theme) ? premiumColor : premiumDarkThemeColor;
};
